import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import {
  Alert,
  AlertsBannersDefinitionsResponse,
  MarketingBanner as MarketingBannerRaw,
} from "@/api/backofficeRest/generated/model"
import { IAlertsBannersCatalogue } from "./alertsBanners.types"
import {
  AlertDefinition,
  AlertsBannersCatalogue,
  MarketingBanner,
} from "./alertsBanners"

export type AlertsBannersRaw = AlertsBannersDefinitionsResponse

const toBanner = (raw: MarketingBannerRaw) =>
  new MarketingBanner(
    raw.id ?? null,
    raw.enabled ?? null,
    raw.variant ?? null,
    raw.name,
    raw.variantKey,
    raw.title,
    raw.subtitle,
    raw.buttonText ?? null,
    raw.buttonLink ?? null,
    raw.illustrationName,
    raw.tags,
    raw.platforms,
    new Map((raw.priority ?? []).map((p) => [p.tag, p.priority])),
  )

const toAlert = (raw: Alert) =>
  new AlertDefinition(
    raw.name,
    raw.severity,
    raw.title,
    raw.subtitle,
    raw.isDismissible,
    raw.tags,
    raw.priority ?? null,
    raw.buttonText ?? null,
    raw.buttonLink ?? null,
    raw.actionTag ?? null,
  )

export const AlertsBannersParser: IParser<
  IAlertsBannersCatalogue,
  AlertsBannersRaw
> = {
  toDomain(data: AlertsBannersRaw): IAlertsBannersCatalogue {
    try {
      return new AlertsBannersCatalogue(
        (data.banners ?? []).map(toBanner),
        (data.alerts ?? []).map(toAlert),
      )
    } catch (e) {
      throw new ParseError(e)
    }
  },
}
